import { Injectable } from '@angular/core';
import { DriverManagementService } from './driver-management.service';
import { forkJoin, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DriverImageUploadService {
  constructor(private driverManagementService: DriverManagementService) {}

  //   validate files for count and extension
  validateFiles(files: File[], expectedCount: number, allowedExtension = 'jpg'): { isValid: boolean; warning: boolean } {
    if (files.length === 0 || files.length !== expectedCount) {
      return { isValid: false, warning: true };
    }

    for (const file of Array.from(files)) {
      const fileExtension = file.name.substring(file.name.length - 3).toLowerCase();
      if (fileExtension !== allowedExtension) {
        return { isValid: false, warning: true };
      }
    }

    return { isValid: true, warning: false };
  }

  //   for read files as data url and return promise
  readFilesAsDataURL(files: File[]): Promise<string[]> {
    const fileReadPromises: Promise<string>[] = Array.from(files).map(
      (file) =>
        new Promise<string>((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (e: any) => resolve(e.target.result);
          reader.onerror = () => reject('Error reading file');
          reader.readAsDataURL(file);
        })
    );

    return Promise.all(fileReadPromises);
  }

  //  processs images part
  processImages(dataUrls: string[], isReplaceMode: boolean, invalidSampleIndices: number[], existingImages): any[] {
    let iterator = 0;
    if (isReplaceMode) {
      invalidSampleIndices.forEach((index) => {
        existingImages[index] = {
          imageUrl: dataUrls[iterator],
          isValid: undefined,
          sampleId: undefined,
        };
        iterator++;
      });
    } else {
      dataUrls.forEach((dataUrl) => {
        existingImages.push({
          imageUrl: dataUrl,
          isValid: undefined,
          sampleId: undefined,
        });
      });
    }

    return existingImages;
  }

  /**
   * Uploads files to S3.
   * @param sampleIdsList List of S3 URLs for uploading.
   * @param fileList List of files to be uploaded.
   * @returns Observable of the upload process.
   */

  uploadFilesToS3(sampleIdsList, fileList: File[]): Observable<any> {
    const uploadRequests = sampleIdsList.map((x: any, idx: number) => this.driverManagementService.uploadFileToS3(x.url, fileList[idx]));

    return forkJoin(uploadRequests);
  }
}
